import { CircularProgress, Grid, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";
import { Button } from "Components/Form";

export const EmptyDiv = styled("div")(() => ({
  border: "1px solid #eaebef",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "center",
  height: "100%",
  width: "100%",
  borderRadius: "5px",
  textAlign: "center",
  minHeight: "64px",
}));

export const EmptyText = styled("span")(() => ({
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize: "16px",
  color: colors.gray600,
  lineHeight: "24px",
}));

export const GridActionItemContainer = styled("span", {
  shouldForwardProp(propName) {
    return propName !== "active";
  },
})<{ active?: boolean }>(({ active }) => ({
  borderRadius: "50%",
  cursor: "pointer",
  backgroundColor: active ? colors.gray200 : "transparent",
  width: "24px",
  height: "24px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const DisabledGridActionItemContainer = styled("span")(() => ({
  backgroundColor: "transparent",
  width: "24px",
  height: "24px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const GridActionContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  gap: 4,
}));

export const RightActionsGrid = styled(Grid)(() => ({
  width: "max-content",
}));

export const ExportCSVButton = styled(Button)(() => ({
  width: 135,
}));

export const OpenSubscriptionDrawIconButton = styled(IconButton)(() => ({
  borderRadius: "8px !important",
  borderColor: `${colors.brandBlue500} !important`,
  borderWidth: "1px !important",
  borderStyle: "solid !important",
  padding: "8px !important",
  "&:hover": {
    backgroundColor: "#0055A414 !important",
  },
}));

export const LoadingSpinner = styled(CircularProgress)(() => ({
  color: `${colors.gray600} !important`,
}));
